import React from 'react';
import { createRoot } from 'react-dom/client';
import noop from 'lodash/noop';
import URL from 'url-parse';
import { ActiveUIProvider } from '@active/react-ui/ActiveUIContext';
import classnames from 'classnames';
import pubSubInstance from '../../shared/utils/pubSub';
import { bodyLoadingCreator } from '../../components/common/Loading';
import { styleOverride } from '../../shared/utils/commonUtils';
import '../css/style.scss';

const {
  origin, protocol, host, hostname, port, query, hash,
} = new URL(document.URL, true);

const hostInfo = {
  origin, protocol, host, hostname, port, query, hash,
};
export default Widget => (container, props) => {
  const {
    locale, show: marketCustomizedShow, hide: marketCustomizedHide, overrideStyles, trackingCallback = noop,
  } = props;
  overrideStyles && Widget.elemClassName && styleOverride({ nameSpace: Widget.elemClassName, overrideStyles });

  let show;
  let hide;
  let clear;
  const useCustomizeLoading = marketCustomizedShow && marketCustomizedHide;
  if (!useCustomizeLoading) {
    ({ show, hide, clear } = bodyLoadingCreator('checkout__widgets'));
  } else {
    show = marketCustomizedShow;
    hide = marketCustomizedHide;
  }

  const className = classnames('checkout-ui-component', Widget.widgetNameSpace);

  const root = createRoot(container);
  root.render(
    <div className='checkout_root'>
      <div className='checkout_container'>
        <div className="checkout__widgets">
          <div id="aaui-popover-container" className={className}/>
          <ActiveUIProvider value={{ getRootElement: () => document.getElementById('aaui-popover-container') }}>
            <Widget
              hostInfo={hostInfo}
              {...props}
              trackingCallback={trackingCallback}
              widgetAPIServerHost={window.CUIWidget.apiHost}
              show={show}
              hide={hide}
              widgetNameSpace={Widget.widgetNameSpace}
              widgetUpdateEventName={Widget.eventName}
              locale={locale || 'en_US'} />
          </ActiveUIProvider>
        </div>
      </div>
    </div>);
  return {
    destroy() {
      !useCustomizeLoading && clear();
      root.unmount();
    },
    widgetDataUpdater: Widget.eventName ? (data) => {
      pubSubInstance.dispatch(`${Widget.widgetNameSpace}-${Widget.eventName}`, data);
    } : noop,
  };
};
